import TemplateItemsData from "./TemplateItemsData";

// 輪播媒體型態判斷（HomeSlider 共用，避免兩邊各自維護一份副檔名清單）
const VIDEO_EXT = /\.(webm|mp4)$/i;
export const isVideo = (src) => VIDEO_EXT.test(src || "");

// 根據模板編號獲取模板資料的輔助函數
const getTemplateData = (templateCode) => {
  return TemplateItemsData.find(
    (template) => template.template_link === templateCode,
  );
};

// 獲取完整的輪播圖資料（合併模板資料）
const getSliderWithTemplateData = (sliderItem) => {
  const templateData = getTemplateData(sliderItem.template_code);

  if (!templateData) {
    console.warn(
      `找不到或已下架模板 ${sliderItem.template_code} 的資料，已自動從輪播移除`,
    );
    return null;
  }

  return {
    ...sliderItem,
    slider_link: `/template/${sliderItem.template_code}/intro`,
    slider_template_element: sliderItem.template_code,
    slider_template_title: templateData.template_title,
    slider_template_category_name: templateData.template_category_name,
    template_intro: templateData.template_intro,
    template_category: templateData.template_category,
    template_tag: templateData.template_tag,
  };
};

/**
 * 開發期防呆：slider_img 是影片時，必須一併提供 slider_poster
 * 背景模糊層只吃靜態圖，缺 poster 會變成黑框
 * @param {any[]} items - 已合併模板資料的輪播清單
 */
const validateSliderPosters = (items) => {
  if (process.env.NODE_ENV === "production") return;

  const problems = items
    .filter((item) => isVideo(item.slider_img) && !item.slider_poster)
    .map(
      (item) =>
        `[SliderData] ${item.template_code} 的 slider_img 是影片但未提供 slider_poster，背景模糊層將無圖可用`,
    );

  if (problems.length) {
    console.warn(problems.join("\n"));
  }
};

// 簡化輪播圖基礎資料 - 只需要指定模板編號即可，會自動濾掉下架模板
//
// slider_img：支援 .jpg / .png / .webp，也支援 .webm / .mp4
//   - 靜態圖 → 停留 3 秒後換頁
//   - 影片   → 播放完畢(ended)才換頁，且必須另外提供 slider_poster
// slider_poster：影片張必填，同時給兩個地方用：
//   1. 前景 <video poster>：影片解碼出第一幀前顯示，也是播不動時的退路
//   2. 背景模糊層：該層有 blur + brightness 蓋著
//   ★ 必須是「影片的第一幀」，否則進場時會看到 poster 閃一下才換成影片。
//     取法：ffmpeg -i slider01.webm -frames:v 1 -q:v 3 slider01_poster.jpg
//     因為前景會原尺寸顯示，不可為了背景層而壓小。靜態圖張不需填。
//
// 影片張的寫法範例：
//   {
//     slider_id: 1,
//     slider_img: "./images/slider/slider01.webm",
//     slider_poster: "./images/slider/slider01_poster.jpg",
//     template_code: "E36",
//     category_id: 0,
//   },
const SliderBaseData = [
  {
    slider_id: 1,
    slider_img: "./images/slider/slider01.webm",
    slider_poster: "./images/slider/slider01_poster.jpg", //影片張必填，須為影片第一幀
    template_code: "E36", // 只需要輸入模板編號
    category_id: 0, // 如果需要連到faq的分類ID
  },
  {
    slider_id: 2,
    slider_img: "./images/slider/slider02.webm",
    slider_poster: "./images/slider/slider02_poster.jpg", //影片張必填，須為影片第一幀
    template_code: "E33",
    category_id: 0,
  },
  {
    slider_id: 3,
    slider_img: "./images/slider/slider03.webm",
    slider_poster: "./images/slider/slider03_poster.jpg", //影片張必填，須為影片第一幀
    template_code: "E25",
    category_id: 0,
  },
  // {
  //   slider_id: 1,
  //   slider_img: "./images/slider/slider01.jpg",
  //   template_code: "E34", // 只需要輸入模板編號
  //   category_id: 0, // 如果需要連到faq的分類ID
  // },
  // {
  //   slider_id: 2,
  //   slider_img: "./images/slider/slider02.jpg",
  //   template_code: "E29",
  //   category_id: 0,
  // },
  // {
  //   slider_id: 3,
  //   slider_img: "./images/slider/slider03.jpg",
  //   template_code: "E05",
  //   category_id: 0,
  // },
];

// 自動生成完整的輪播圖資料
const SliderData = SliderBaseData.map(getSliderWithTemplateData).filter(
  Boolean,
);

validateSliderPosters(SliderData);

export default SliderData;
